import { f as Z, C as k, D as L, d as B, E as N, U as K, L as D, _ as Y, M as rr, j as er, u as tr, q as ar, e as or, c as nr } from "./export-cdcbfb2b.js";
import { b as ir, c as sr } from "./create-property-f9780ed1.js";
import { s as U, c as $, d as vr } from "./iterate-13ada9e5.js";
import { o as fr } from "./object-create-9b6715a2.js";
import { a as F } from "./object-to-array-0474b7e7.js";
import { o as ur } from "./object-set-prototype-of-7d7e5736.js";
var lr = Z, cr = k, yr = L, E = F, pr = B, Ir = N, m = Ir("iterator"), M = !1, v, P, d;
[].keys && (d = [].keys(), "next" in d ? (P = E(E(d)), P !== Object.prototype && (v = P)) : M = !0);
var Rr = !yr(v) || lr(function() {
  var r = {};
  return v[m].call(r) !== r;
});
Rr && (v = {});
cr(v[m]) || pr(v, m, function() {
  return this;
});
var V = {
  IteratorPrototype: v,
  BUGGY_SAFARI_ITERATORS: M
}, Or = V.IteratorPrototype, Tr = fr, Pr = K, dr = U, Sr = $, mr = function() {
  return this;
}, $r = function(r, e, t, u) {
  var a = e + " Iterator";
  return r.prototype = Tr(Or, { next: Pr(+!u, t) }), dr(r, a, !1), Sr[a] = mr, r;
}, _r = Y, br = er, q = D, Ar = k, Er = $r, g = F, h = ur, gr = U, hr = rr, S = B, jr = N, Gr = $, W = V, wr = q.PROPER, Cr = q.CONFIGURABLE, j = W.IteratorPrototype, R = W.BUGGY_SAFARI_ITERATORS, c = jr("iterator"), G = "keys", y = "values", w = "entries", xr = function() {
  return this;
}, kr = function(r, e, t, u, a, J, Q) {
  Er(t, e, u);
  var p = function(n) {
    if (n === a && s)
      return s;
    if (!R && n && n in o)
      return o[n];
    switch (n) {
      case G:
        return function() {
          return new t(this, n);
        };
      case y:
        return function() {
          return new t(this, n);
        };
      case w:
        return function() {
          return new t(this, n);
        };
    }
    return function() {
      return new t(this);
    };
  }, X = e + " Iterator", T = !1, o = r.prototype, f = o[c] || o["@@iterator"] || a && o[a], s = !R && f || p(a), b = e === "Array" && o.entries || f, i, l, I;
  if (b && (i = g(b.call(new r())), i !== Object.prototype && i.next && (g(i) !== j && (h ? h(i, j) : Ar(i[c]) || S(i, c, xr)), gr(i, X, !0))), wr && a === y && f && f.name !== y && (Cr ? hr(o, "name", y) : (T = !0, s = function() {
    return br(f, this);
  })), a)
    if (l = {
      values: p(y),
      keys: J ? s : p(G),
      entries: p(w)
    }, Q)
      for (I in l)
        (R || T || !(I in o)) && S(o, I, l[I]);
    else
      _r({ target: e, proto: !0, forced: R || T }, l);
  return o[c] !== s && S(o, c, s, { name: a }), Gr[e] = s, l;
}, Br = function(r, e) {
  return { value: r, done: e };
}, Nr = nr, _ = ir, C = $, z = or, Yr = tr.f, Ur = kr, O = Br, Fr = ar, H = "Array Iterator", Mr = z.set, Vr = z.getterFor(H), Kr = Ur(Array, "Array", function(r, e) {
  Mr(this, {
    type: H,
    target: Nr(r),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var r = Vr(this), e = r.target, t = r.index++;
  if (!e || t >= e.length)
    return r.target = null, O(void 0, !0);
  switch (r.kind) {
    case "keys":
      return O(t, !1);
    case "values":
      return O(e[t], !1);
  }
  return O([t, e[t]], !1);
}, "values"), x = C.Arguments = C.Array;
_("keys");
_("values");
_("entries");
if (Fr && x.name !== "values")
  try {
    Yr(x, "name", { value: "values" });
  } catch {
  }
var qr = Y, Wr = vr, zr = sr;
qr({ target: "Object", stat: !0 }, {
  fromEntries: function(e) {
    var t = {};
    return Wr(e, function(u, a) {
      zr(t, u, a);
    }, { AS_ENTRIES: !0 }), t;
  }
});
export {
  $r as a,
  Br as c,
  Kr as e,
  kr as i
};
